module.exports = __webpack_public_path__ + "img/logo.072a8c66.png";